@let subStoryValue = subStory();

@switch (subStoryValue.type) {
    @case (SubStoryType.Image) {
        <img priority disableOptimizedSrcset placeholder ngSrcset="1x, 2x, 3x" [width]="540" [height]="786" [ngSrc]="subStoryValue.image" />
    }
    @case (SubStoryType.Video) {
        <ms-story-content-video
            [videoUrl]="subStoryValue.externalVideoUrl ?? subStoryValue.videoUrl"
            [subStoryId]="subStoryValue.id"
            [storyId]="story().id" />
    }
    @case (SubStoryType.Promotion) {
        @if (subStoryValue.crmPromotionBackground) {
            <img
                priority
                disableOptimizedSrcset
                placeholder
                ngSrcset="1x, 2x, 3x"
                [width]="540"
                [height]="786"
                [ngSrc]="subStoryValue.crmPromotionBackground" />
        }
        <ms-story-promotion [promotion]="subStoryValue.promotion" [storyTitle]="story().title" (detailsPopupChange)="setProgressBarStatus($event)" />
    }
}
